import { ensureSingleTagExists, ensureTagNotExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

export interface IWithFurnitureTag {
  type: 'advanced-withFurniture';
}

function isWithFurnitureTag(tag: TTag): tag is IWithFurnitureTag {
  return tag.type === 'advanced-withFurniture';
}

export const withFurnitureTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const value = jsonQuery.with_furniture?.value;

    if (value) {
      return ensureSingleTagExists(tags, isWithFurnitureTag, () => ({ type: 'advanced-withFurniture', value }));
    } else {
      return ensureTagNotExists(tags, isWithFurnitureTag);
    }
  },
};
